import { Component, Input, NgModule } from '@angular/core';
import { SignOffStepComponent } from '@data-terminal/feature-dialogs/components/sign-off-component.abstract';
import { SignOffMachine } from '@data-terminal/shared-models/machine';
import {
    isOperationActivityRunning,
    shouldHandleOperationBecauseAssistantsWillBeLoggedOff,
} from '@data-terminal/feature-dialogs/services/processes/sign-off-process.functions';
import { isCurrentUserAnOperator } from '@data-terminal/utils/functions';
import { SignOffOperationCardModule } from '@data-terminal/feature-dialogs/components/sign-off-operations/sign-off-operations-card/sign-off-operation-card.component';
import { SignOffOperation } from '@data-terminal/shared-models/dialogs/sign-off-dialog';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'data-terminal-sign-off-operations',
    templateUrl: './sign-off-operations.component.html',
    styleUrls: ['./sign-off-operations.component.scss'],
    standalone: false,
})
export class SignOffOperationsComponent extends SignOffStepComponent<SignOffOperation> {
    @Input() public userId!: string;

    public override shouldDisplayCard(signOffData: SignOffMachine): boolean {
        const shouldDisplay =
            shouldHandleOperationBecauseAssistantsWillBeLoggedOff(signOffData) &&
            isOperationActivityRunning(signOffData.machine) &&
            isCurrentUserAnOperator(signOffData.machine, this.userId);
        if (!shouldDisplay) {
            this.validityMap.delete(signOffData.machineId);
        }
        return shouldDisplay;
    }
}

@NgModule({
    declarations: [SignOffOperationsComponent],
    exports: [SignOffOperationsComponent],
    imports: [SignOffOperationCardModule, CommonModule, TranslateModule],
})
export class SignOffOperationsModule {}
